import { Routes } from '@angular/router';
import { platformAuthGuard } from './core/guards/platform-auth.guard';
import { AdminLayoutComponent } from './shared/components/admin-layout/admin-layout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/super-admin/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.AUTH_ROUTES)
  },
  {
    path: 'dashboard',
    redirectTo: '/super-admin/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'users',
    redirectTo: '/super-admin/users',
    pathMatch: 'full'
  },
  {
    path: 'system',
    redirectTo: '/super-admin/monitoring',
    pathMatch: 'full'
  },
  {
    path: 'audit',
    redirectTo: '/super-admin/audit',
    pathMatch: 'full'
  },
  {
    path: 'analytics',
    redirectTo: '/super-admin/analytics',
    pathMatch: 'full'
  },
  {
    path: 'settings',
    redirectTo: '/super-admin/config',
    pathMatch: 'full'
  },
  {
    path: 'api-management',
    redirectTo: '/super-admin/config',
    pathMatch: 'full'
  },
  {
    path: 'monitoring',
    redirectTo: '/super-admin/monitoring',
    pathMatch: 'full'
  },
  {
    path: 'parsing-engine',
    component: AdminLayoutComponent,
    canActivate: [platformAuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./features/parsing-engine/parsing-engine.routes').then(m => m.PARSING_ENGINE_ROUTES)
      }
    ]
  },
  {
    path: 'super-admin',
    loadChildren: () => import('./features/super-admin/super-admin.routes').then(m => m.superAdminRoutes)
  },
  {
    path: '**',
    redirectTo: '/super-admin/dashboard'
  }
];

